import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  offlineToast: any;
  currentToast: any = null;
  constructor(public toastController: ToastController, private translate: TranslateService) {

  }
  async show(message: string, duration: number = 3000, position: 'top' | 'middle' | 'bottom' = 'middle', color: string = 'primary') {
    if (!message) return;
    if (message) {
      if (!duration)
        duration = 3000;
      if (!color)
        color = "primary"
      if (!position)
        position = "bottom";
      this.currentToast = await this.toastController.create({
        message,
        duration,
        position,
        color,
        cssClass: 'multi-line-toast'
      });
      await this.currentToast.present();
      this.currentToast = true;
    }
  }
  async showWithCloseButton(message: string, cssClass: any, position: any, color: any, callback: any, button?: any) {
    if (message) {
      if (!color)
        color = "primary"
      if (!position)
        position = "middle";
      if (!cssClass)
        cssClass = "";
      if (!button)
        button = this.translate.instant("OK")
      this.currentToast = await this.toastController.create({
        message: message,
        position: position,
        cssClass: cssClass,
        color: color,
        buttons: [
          {
            text: button,
            handler: () => {
              if (typeof callback === 'function') {
                callback();
              }
            }
          }
        ]
      });
      if (cssClass == "offline-toast")
        this.offlineToast = this.currentToast;
      await this.currentToast.present();
      this.currentToast = true;
    }
  }
  clear() {
    setTimeout(async () => {
      if (this.currentToast) {
        this.currentToast = null;
        return await this.toastController.dismiss();
      }
      return null;
    }, 2000);
  }
}